import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Login from "./pages/login.js";
import DashboardLayout from "./components/DashboardLayout.js";
import Overview from "./pages/Overview.js";
import Controls from "./pages/Controls.js";
import Licenses from "./pages/Licenses.js";
import { DashboardProvider } from "./context/DashboardContext.js";

// PrivateRoute component to protect authenticated console routes
function PrivateRoute({ children }) {
  const [checking, setChecking] = useState(true);
  const [valid, setValid] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setValid(false);
      setChecking(false);
      return;
    }
    axios
      .post("https://license-worker.alphatrendz99.workers.dev/api/verify", { token })
      .then((res) => {
        setValid(res.data.valid);
        setChecking(false);
      })
      .catch(() => {
        setValid(false);
        setChecking(false);
      });
  }, []);

  if (checking) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "14px",
          backgroundColor: "var(--bg-0)",
          color: "var(--text-1)",
          fontFamily: "var(--font-mono)",
          fontSize: "12px",
          letterSpacing: "0.14em",
        }}
      >
        <span className="status-dot green pulse" style={{ width: "10px", height: "10px" }} />
        <span>VERIFYING SESSION ENCRYPTION...</span>
      </div>
    );
  }

  return valid ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        
        {/* Protected Dashboard Layout and Sub-routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardProvider>
                <DashboardLayout />
              </DashboardProvider>
            </PrivateRoute>
          }
        >
          <Route index element={<Overview />} />
          <Route path="controls" element={<Controls />} />
          <Route path="licenses" element={<Licenses />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>

        {/* Global Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
